import React from 'react';

export class RegionSelector extends React.Component {
    constructor(props){
        super(props);
    }
    
    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps){
            return true;
        }
        return false;
    }

    render() {
        if(this.props.error)
        {
            return <p>Something went wrong when loading regions. Try again!</p>
        }
        else
        {
            let content;
            if(!this.props.loadingRegions && this.props.regions.length === 0){
                content = <p>No regions added!</p>
            }
            else{
                content = this.props.loadingRegions ? <p>Loading regions..</p> : 
                this.renderDropdown();
            }

            return content;
        }
    }
    
    renderDropdown(){
        return <div className="region-selector">
        <select value={this.props.value} onChange={this.props.onRegionChange} className="btn btn-default dropdown-toggle">
            {this.props.regions.map((region, index) => {
                return <SelectOptionItems value={region.Id} key={region.Id} name={region.Name} />
            })}
        </select>
        </div>;
    }
}

export class SelectOptionItems extends React.Component {
    constructor(props){
        super(props);
    }

    render() { 
        return <option value={this.props.value}>
                    {this.props.name}
                </option>;
    }
}

